import React, { useState, useEffect } from 'react';

import {
  StyledForm,
  StyledPropertySelection,
  StyledRoomTypeSelection,
  StyledRoomViewsSelection,
  StyledSortingCriteriaSelection
} from './Filters.styles';

import { SPECIAL_HOST_IDS } from 'utils/constants'; // Import the special host IDs
import { Row, Col } from 'antd';

const Filters = ({
  form,
  roomViewsSelection,
  sortingCriteriaSelection,
  propertySelection,
  roomTypeSelection,
  propertyId,
  roomTypeId,
  roomViews,
  sortingCriteria,
  onPropertyChange,
  onRoomTypeChange,
  onRoomViewsChange,
  onSortingCriteriachange,
  host,
  hostId,
  homepage
}) => {
  const [isSpecialHost, setIsSpecialHost] = useState(false);
  useEffect(() => {
    // console.log('host', host);

    if (host._id) {
      const SpecialHostCheck = SPECIAL_HOST_IDS.includes(host._id);

      setIsSpecialHost(SpecialHostCheck);
    }
  }, [host]);
  if (!!host && !!host.allowBookingEngine) {
    return (
      <StyledForm
        form={form}
        initialValues={{
          property: propertyId,
          roomType: roomTypeId,
          roomViews,
          sortingCriteria
        }}
      >
        {homepage === false && (
          <StyledPropertySelection name="property" selections={propertySelection} placeholder="Property name" onChange={onPropertyChange} />
        )}
        {/* {homepage === false && <StyledSortingCriteriaSelection
          name="sortingCriteria"
          selections={sortingCriteriaSelection}
          isAllowClear={false}
          onChange={onSortingCriteriachange}
        />} */}
      </StyledForm>
    );
  }
  return (
    <StyledForm
      form={form}
      initialValues={{
        property: propertyId,
        roomType: roomTypeId,
        roomViews,
        sortingCriteria
      }}
    >
      <StyledPropertySelection name="property" selections={propertySelection} placeholder="Property name" onChange={onPropertyChange} />

      {isSpecialHost && (
        <Row gutter={24}>
          <Col>
            <a
              href={require('../../../../../images/student-handbook.pdf')}
              rel="noopener noreferrer"
              target="_blank"
              style={{
                fontSize: 20,
                fontWeight: 'bold'
              }}
            >
              Student Handbook.pdf
            </a>
          </Col>

          <Col>
            <a
              href={require('../../../../../images/do-and-dont.pdf')}
              rel="noopener noreferrer"
              target="_blank"
              style={{
                fontSize: 20,
                fontWeight: 'bold'
              }}
            >
              DO & DONT.pdf
            </a>
          </Col>
        </Row>
      )}

      {!!host.allowBookingEngine && (
        <StyledRoomTypeSelection name="roomType" selections={roomTypeSelection} placeholder="Types of room / units" onChange={onRoomTypeChange} />
      )}
      {!!host.allowBookingEngine && (
        <StyledRoomViewsSelection
          isMultiple={true}
          name="roomViews"
          selections={roomViewsSelection}
          placeholder="Views of room / units"
          onChange={onRoomViewsChange}
        />
      )}
      {!!host.allowBookingEngine && (
        <StyledSortingCriteriaSelection
          name="sortingCriteria"
          selections={sortingCriteriaSelection}
          isAllowClear={false}
          onChange={onSortingCriteriachange}
        />
      )}
    </StyledForm>
  );
};

export default Filters;
